export class TableCore {
  id!: string;

  name!: string;

  dbTableName!: string;

  icon?: string;

  lastModifiedTime!: string;

  defaultViewId!: string;
}
